<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <section>
      <div id="page-accordion" *ngIf="provider">
        <div class="col-12 card" [ngClass]="activeTable === 'masterdata' ? 'active' : ''" [formGroup]="masterDataForm">
          <div class="card-title d-flex align-items-center mb-0 px-1" (click)="activeTable = 'masterdata'">
            <h3>{{ "MENU.EXTERNAL_USERS_LIST" | translate }}</h3>
          </div>
          <div class="card-body px-1 pt-2 pb-1" *ngIf="activeTable === 'masterdata'">
            <div class="row">
              <div class="form-group col-lg-6 col-12">
                <div class="{{ provider && provider.logo ? 'd-flex align-items-center' : null }}">
                  <figure class="mr-2 flex-basis-10 mb-0" [ngClass.sm]="'d-none'" *ngIf="provider && provider.logo">
                    <img [src]="provider.logo" class="img-cover" [alt]="provider.name" />
                  </figure>
                  <div [ngClass.xl]="'flex-basis-90'" [ngClass.sm]="'flex-basis-100'" [ngClass.md]="'flex-basis-90'">
                    <fieldset class="mb-0">
                      <label for="logo">{{ "LOGO" | translate }}</label>
                      <div class="custom-file">
                        <input class="custom-file-input" type="file" lang="it" id="logo" accept="image/*" (change)="handlerChangeFileInput($event)" />
                        <label *ngIf="!fileName" class="custom-file-label">{{ "SELECT_FILE" | translate }}</label>
                        <label *ngIf="fileName && fileName.length > 0" class="custom-file-label">{{ fileName }}</label>
                      </div>
                    </fieldset>
                  </div>
                </div>
              </div>
              <div class="form-group col-md-6 col-12">
                <label for="name">{{ "NAME" | translate }}:<sup class="text-danger">*</sup></label>
                <input type="text" id="name" class="form-control {{ masterDataHasError('name') ? 'is-invalid' : '' }}" formControlName="name" />
                <div class="invalid-feedback" *ngIf="masterDataForm.controls.name.errors?.required">{{ "ERRORS.FIELD_NAME" | translate }}</div>
                <div class="invalid-feedback" *ngIf="masterDataForm.controls?.name?.errors?.minlength">{{ "MIN" | translate }} 2 {{ "CHARACTERS" | translate }}</div>
                <div class="invalid-feedback" *ngIf="masterDataForm.controls?.name?.errors?.maxlength">{{ "MAX" | translate }} 255 {{ "CHARACTERS" | translate }}</div>
              </div>
              <div class="form-group col-lg-6 col-12">
                <label for="business_name">{{ "BUSINESS_NAME" | translate }}:<sup class="text-danger">*</sup></label>
                <input type="text" id="business_name" class="form-control {{ masterDataHasError('business_name') ? 'is-invalid' : '' }}" formControlName="business_name" />
                <div class="invalid-feedback" *ngIf="masterDataForm.controls.business_name.errors?.required">{{ "ERRORS.FIELD_BUSINESS_NAME" | translate }}</div>
                <div class="invalid-feedback" *ngIf="masterDataForm.controls?.business_name?.errors?.minlength">{{ "MIN" | translate }} 2 {{ "CHARACTERS" | translate }}</div>
                <div class="invalid-feedback" *ngIf="masterDataForm.controls?.business_name?.errors?.maxlength">{{ "MAX" | translate }} 255 {{ "CHARACTERS" | translate }}</div>
              </div>
              <div class="form-group col-lg-6 col-12">
                <label for="vat_number">{{ "VAT_NUMBER" | translate }}</label>
                <input type="text" id="vat_number" class="form-control {{ masterDataHasError('vat_number') ? 'is-invalid' : '' }}" formControlName="vat_number" />
                <div class="invalid-feedback" *ngIf="masterDataForm.controls.vat_number.errors?.required">{{ "ERRORS.FIELD_VAT_NUMBER" | translate }}</div>
                <div class="invalid-feedback" *ngIf="masterDataForm.controls?.vat_number?.errors?.minlength">{{ "MIN" | translate }} 9 {{ "CHARACTERS" | translate }}</div>
                <div class="invalid-feedback" *ngIf="masterDataForm.controls?.vat_number?.errors?.maxlength">{{ "MAX" | translate }} 12 {{ "CHARACTERS" | translate }}</div>
              </div>
              <div class="form-group col-lg-6 col-12">
                <label for="fiscalcode">{{ "FISCAL_CODE" | translate }}:</label>
                <input type="text" id="fiscalcode" class="form-control" formControlName="fiscalcode" />
              </div>
              <div class="form-group col-lg-6 col-12">
                <label for="bank">{{ "BANK" | translate }}:<sup class="text-danger">*</sup></label>
                <ng-select
                  id="bank"
                  bindLabel="name"
                  bindValue="id"
                  formControlName="bank"
                  [multiple]="false"
                  [searchable]="true"
                  [closeOnSelect]="true"
                  class="{{ masterDataHasError('bank') ? 'is-invalid' : '' }}"
                  [clearable]="false"
                  [openOnEnter]="false"
                  [virtualScroll]="true"
                  [items]="banksList"
                ></ng-select>
                <div class="invalid-feedback" *ngIf="masterDataForm.controls.bank.errors?.required">{{ "ERRORS.FIELD_BANK" | translate }}</div>
              </div>
              <div class="form-group col-lg-6 col-12">
                <label for="email">{{ "EMAIL" | translate }}:</label>
                <input type="text" id="email" class="form-control {{ masterDataHasError('email') ? 'is-invalid' : '' }}" formControlName="email" />
                <div class="invalid-feedback" *ngIf="masterDataForm.controls?.email?.errors?.minlength">{{ "MIN" | translate }} 2 {{ "CHARACTERS" | translate }}</div>
                <div class="invalid-feedback" *ngIf="masterDataForm.controls?.email?.errors?.maxlength">{{ "MAX" | translate }} 255 {{ "CHARACTERS" | translate }}</div>
                <div class="invalid-feedback" *ngIf="masterDataForm.controls?.email?.errors?.pattern">{{ "ERRORS.INVALID_CHARACTER_INSERTED" | translate }}</div>
              </div>
              <div class="form-group col-lg-6 col-12">
                <label for="pec">{{ "PEC" | translate }}:</label>
                <input type="text" id="pec" class="form-control {{ masterDataHasError('pec') ? 'is-invalid' : '' }}" formControlName="pec" />
                <div class="invalid-feedback" *ngIf="masterDataForm.controls?.pec?.errors?.minlength">{{ "MIN" | translate }} 2 {{ "CHARACTERS" | translate }}</div>
                <div class="invalid-feedback" *ngIf="masterDataForm.controls?.pec?.errors?.maxlength">{{ "MAX" | translate }} 255 {{ "CHARACTERS" | translate }}</div>
                <div class="invalid-feedback" *ngIf="masterDataForm.controls?.pec?.errors?.pattern">{{ "ERRORS.INVALID_CHARACTER_INSERTED" | translate }}</div>
              </div>
              <div class="form-group col-lg-4 col-12">
                <label for="recipient_pec">{{ "RECIPIENT_PEC" | translate }}:</label>
                <input type="text" id="recipient_pec" class="form-control {{ masterDataHasError('recipient_pec') ? 'is-invalid' : '' }}" formControlName="recipient_pec" />
                <div class="invalid-feedback" *ngIf="masterDataForm.controls?.recipient_pec?.errors?.minlength">{{ "MIN" | translate }} 2 {{ "CHARACTERS" | translate }}</div>
                <div class="invalid-feedback" *ngIf="masterDataForm.controls?.recipient_pec?.errors?.maxlength">{{ "MAX" | translate }} 255 {{ "CHARACTERS" | translate }}</div>
                <div class="invalid-feedback" *ngIf="masterDataForm.controls?.recipient_pec?.errors?.pattern">{{ "ERRORS.INVALID_CHARACTER_INSERTED" | translate }}</div>
              </div>
              <div class="col-lg-4 col-12">
                <label for="invoice_type">{{ "INVOICE_TYPE" | translate }}:<sup class="text-danger">*</sup></label>
                <ng-select
                  id="invoice_type"
                  bindLabel="name"
                  bindValue="id"
                  formControlName="invoice_type"
                  [multiple]="false"
                  [searchable]="true"
                  [closeOnSelect]="true"
                  class="{{ masterDataHasError('invoice_type') ? 'is-invalid' : '' }}"
                  [clearable]="false"
                  [openOnEnter]="false"
                  [virtualScroll]="true"
                  [items]="invoiceTypeList"
                ></ng-select>
                <div class="invalid-feedback" *ngIf="masterDataForm.controls.invoice_type.errors?.required">{{ "ERRORS.INSERT_INVOICE_TYPE" | translate }}</div>
              </div>
              <div class="form-group col-lg-4 col-12">
                <label for="unique_code">{{ "UNIQUE_CODE" | translate }}:</label>
                <input type="text" id="unique_code" class="form-control" formControlName="unique_code" />
              </div>
              <div class="col-12 text-right pt-1">
                <button type="button" class="btn btn-primary" (click)="save()">{{ "SAVE" | translate }}</button>
              </div>
            </div>
          </div>
        </div>
        <div class="card col-12" [ngClass]="activeTable === 'sites' ? 'active pb-0' : ''" [formGroup]="siteForm">
          <div class="card-title d-flex align-items-center mb-0 px-1" (click)="activeTable = 'sites'">
            <div class="row w-100">
              <div class="col-lg-6 col-12">
                <h3>{{ "PLACE_SINGULAR" | translate }}</h3>
              </div>
              <div class="col-lg-6 col-12" *ngIf="_utilService.isDesktop && activeTable === 'sites' && provider.addresses.length > 0">
                <h3 class="pl-1">{{ "TITLES.ADD_SITE" | translate }}</h3>
              </div>
            </div>
          </div>
          <div class="card-body row px-0 pb-0" *ngIf="activeTable === 'sites'">
            <div class="col-lg-6 col-12 px-0 border-right" *ngIf="provider.addresses.length > 0">
              <div class="d-flex p-1 border-bottom">
                <div class="flex-basis-100 font-weight-bold" *ngIf="!_utilService.isDesktop">{{ "LABEL" | translate }}</div>
                <div class="flex-basis-30 font-weight-bold" *ngIf="_utilService.isDesktop">{{ "LABEL" | translate }}</div>
                <div class="flex-basis-40 font-weight-bold" *ngIf="_utilService.isDesktop">{{ "ADDRESS" | translate }}</div>
                <div class="flex-basis-20 font-weight-bold" *ngIf="_utilService.isDesktop">{{ "CITY" | translate }}</div>
                <div class="flex-basis-15 font-weight-bold" *ngIf="_utilService.isDesktop">{{ "ACTIONS" | translate }}</div>
              </div>
              <div *ngFor="let address of provider.addresses; let i = index" class="d-flex px-1 py-1" [ngClass]="i < provider.addresses.length - 1 ? 'border-bottom' : ''">
                <div class="flex-basis-100" *ngIf="!_utilService.isDesktop">
                  <div>{{ address.label }}</div>
                  <div class="my-1">{{ address.street }}</div>
                  <div>{{ address.city_name }}</div>
                </div>
                <div class="flex-basis-30" *ngIf="_utilService.isDesktop">{{ address.label }}</div>
                <div class="flex-basis-40" *ngIf="_utilService.isDesktop">{{ address.street }}</div>
                <div class="flex-basis-20" *ngIf="_utilService.isDesktop">{{ address.city_name }}</div>
                <div class="flex-basis-15" *ngIf="_utilService.isDesktop">
                  <button class="bg-transparent border-0 text-secondary pl-0 pr-1" *ngIf="_authenticationService.hasCapability('edit_provider_address')" (click)="enterEditModeSite(address.id)">
                    <i [data-feather]="'edit-2'" size="19"></i>
                  </button>
                  <button class="bg-transparent border-0 text-danger remove-item" *ngIf="_authenticationService.hasCapability('delete_provider_address')" (click)="deleteAddress(address.id)">
                    <i [data-feather]="'trash-2'" size="19"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="col-12" [ngClass]="provider.addresses.length > 0 ? 'col-md-6' : 'px-2'">
              <div class="row">
                <div class="col-12 mt-2 mb-1" *ngIf="!_utilService.isDesktop">
                  <h3>{{ "TITLES.ADD_SITE" | translate }}</h3>
                </div>
                <div class="col-lg-6 col-12 form-group">
                  <label for="label">{{ "LABEL" | translate }}:<sup class="text-danger">*</sup></label>
                  <input type="text" id="label" class="form-control {{ siteHasError('label') ? 'is-invalid' : '' }}" formControlName="label" />
                  <div class="invalid-feedback" *ngIf="siteForm.controls?.label?.errors?.maxlength">{{ "MAX" | translate }} 255 {{ "CHARACTERS" | translate }}</div>
                  <div class="invalid-feedback" *ngIf="siteForm.controls?.label?.errors?.required">{{ "ERRORS.INSERT_LABEL" | translate }}</div>
                </div>
                <div class="col-lg-6 col-12 form-group">
                  <label for="street">{{ "ADDRESS" | translate }}:<sup class="text-danger">*</sup></label>
                  <input type="text" id="street" class="form-control {{ siteHasError('street') ? 'is-invalid' : '' }}" formControlName="street" />
                  <div class="invalid-feedback" *ngIf="siteForm.controls?.street?.errors?.minlength">{{ "MIN" | translate }} 2 {{ "CHARACTERS" | translate }}</div>
                  <div class="invalid-feedback" *ngIf="siteForm.controls?.street?.errors?.maxlength">{{ "MAX" | translate }} 255 {{ "CHARACTERS" | translate }}</div>
                  <div class="invalid-feedback" *ngIf="siteForm.controls?.street?.errors?.required">{{ "ERRORS.INSERT_ADDRESS" | translate }}</div>
                </div>
                <div class="col-lg-6 col-12 form-group" *ngIf="!this.siteForm.value.external">
                  <label for="city">{{ "CITY" | translate }}:</label>
                  <ng-select
                    [formControlName]="'city_id'"
                    id="city"
                    bindLabel="nice_name"
                    bindValue="id"
                    [searchable]="true"
                    [closeOnSelect]="true"
                    [clearable]="false"
                    class="{{ siteHasError('city_id') ? 'is-invalid' : '' }}"
                    [items]="_citiesService.list"
                    [openOnEnter]="false"
                    [virtualScroll]="true"
                    (change)="setAutoProvince()"
                  >
                  </ng-select>
                  <div class="invalid-feedback" *ngIf="siteForm.controls.city_id.errors?.required">{{ "ERRORS.INSERT_ADDRESS" | translate }}</div>
                </div>
                <div class="col-lg-6 col-12 form-group" *ngIf="!this.siteForm.value.external">
                  <label for="province">{{ "ADDRESS_PROVINCE" | translate }}:</label>
                  <ng-select
                    [formControlName]="'province_id'"
                    id="province"
                    bindLabel="nice_name"
                    bindValue="id"
                    [searchable]="true"
                    [closeOnSelect]="true"
                    [clearable]="false"
                    class="{{ siteHasError('province_id') ? 'is-invalid' : '' }}"
                    [items]="_citiesService.list"
                    [openOnEnter]="false"
                    [virtualScroll]="true"
                  >
                  </ng-select>
                  <div class="invalid-feedback" *ngIf="siteForm.controls.province_id.errors?.required">{{ "ERRORS.INSERT_PROVINCE" | translate }}</div>
                </div>
                <div class="col-lg-6 col-12 form-group" *ngIf="!this.siteForm.value.external">
                  <label for="zipcode">{{ "ZIPCODE" | translate }}:</label>
                  <input type="text" id="zipcode" class="form-control {{ siteHasError('zipcode') ? 'is-invalid' : '' }}" formControlName="zipcode" />
                  <div class="invalid-feedback" *ngIf="siteForm.controls.zipcode.errors?.required">{{ "ERRORS.INSERT_ZIPCODE" | translate }}</div>
                  <div class="invalid-feedback" *ngIf="siteForm.controls?.zipcode?.errors?.minlength">{{ "MIN" | translate }} 4 {{ "CHARACTERS" | translate }}</div>
                  <div class="invalid-feedback" *ngIf="siteForm.controls?.zipcode?.errors?.maxlength">{{ "MAX" | translate }} 5 {{ "CHARACTERS" | translate }}</div>
                </div>
                <div class="col-lg-6 col-12 form-group" *ngIf="siteForm.value.external">
                  <label for="country">{{ "COUNTRY" | translate }}:<sup class="text-danger" *ngIf="!!siteForm.value.external">*</sup></label>
                  <ng-select id="country" [items]="nationsWithCodes" bindLabel="name" bindValue="code" [clearable]="false" formControlName="country" [ngClass]="siteHasError('country') ? 'is-invalid' : ''"></ng-select>
                </div>
                <div class="form-group col-lg-6 col-12 d-flex align-items-center">
                  <small class="mr-1">{{ "EXTERNAL_SITE_QUESTION" | translate }}</small>
                  <div class="custom-control custom-control-primary custom-switch">
                    <input type="checkbox" class="custom-control-input" id="customSwitch10" formControlName="external" (change)="manageExternalSite()" />
                    <label class="custom-control-label" for="customSwitch10"> </label>
                  </div>
                </div>
                <div class="col-6 mt-075" *ngIf="isEditModeSite">
                  <button class="btn btn-outline-primary" (click)="resetEditModeSite()">{{ "ALERT.BTN_CANCEL" | translate }}</button>
                </div>
                <div class="pb-2 text-right mt-075" [ngClass]="isEditModeSite ? 'col-6' : 'col-12'">
                  <button *ngIf="!isEditModeSite" class="btn btn-primary" (click)="addAddress()">{{ "SAVE" | translate }}</button>
                  <button *ngIf="isEditModeSite" class="btn btn-primary" (click)="editAddress()">{{ "EDIT" | translate }}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card col-12" [ngClass]="activeTable === 'referents' ? 'active pb-0' : ''" [formGroup]="referentForm">
          <div class="card-title d-flex align-items-center mb-0 px-1" (click)="activeTable = 'referents'">
            <div class="row w-100">
              <div class="col-lg-6 col-12">
                <h3>{{ "REFERENT" | translate }}</h3>
              </div>
              <div class="col-lg-6 col-12" *ngIf="_utilService.isDesktop && activeTable === 'referents' && provider.referents.length > 0">
                <h3 class="pl-1">{{ "ADD_REFERENT" | translate }}</h3>
              </div>
            </div>
          </div>
          <div class="card-body row px-0 pb-0" *ngIf="activeTable === 'referents'">
            <div class="col-lg-6 col-12 px-0 border-right" *ngIf="provider.referents.length > 0">
              <div class="d-flex p-1 border-bottom">
                <div class="flex-basis-30 font-weight-bold" *ngIf="_utilService.isDesktop">{{ "NAME" | translate }}</div>
                <div class="flex-basis-30 font-weight-bold" *ngIf="_utilService.isDesktop">{{ "LASTNAME" | translate }}</div>
                <div class="flex-basis-20 font-weight-bold" *ngIf="_utilService.isDesktop">{{ "PHONE" | translate }}</div>
                <div class="flex-basis-15 font-weight-bold" *ngIf="_utilService.isDesktop">{{ "ACTIONS" | translate }}</div>
              </div>
              <div *ngFor="let referent of provider.referents; let i = index" class="d-flex px-1 pt-1" [ngClass]="i < provider.referents.length - 1 ? 'border-bottom pb-1' : ''">
                <div class="flex-basis-30" *ngIf="_utilService.isDesktop">{{ referent.firstname }}</div>
                <div class="flex-basis-30" *ngIf="_utilService.isDesktop">{{ referent.lastname }}</div>
                <div class="flex-basis-20" *ngIf="_utilService.isDesktop">{{ referent.phone }}</div>
                <div class="flex-basis-15" *ngIf="_utilService.isDesktop">
                  <button class="bg-transparent border-0 text-secondary pl-0 pr-1" *ngIf="_authenticationService.hasCapability('edit_provider_address')" (click)="enterEditModeReferent(referent.id)">
                    <i [data-feather]="'edit-2'" size="19"></i>
                  </button>
                  <button class="bg-transparent border-0 text-danger remove-item" *ngIf="_authenticationService.hasCapability('delete_provider_address')" (click)="deleteReferent(referent.id)">
                    <i [data-feather]="'trash-2'" size="19"></i>
                  </button>
                </div>
              </div>
            </div>
            <div [ngClass]="provider.referents.length < 1 ? 'col-12' : 'col-lg-6'">
              <div class="row">
                <div class="col-12 mt-2 mb-1" *ngIf="!_utilService.isDesktop">
                  <h3>{{ "TITLES.ADD_REFERENT" | translate }}</h3>
                </div>
                <div class="col-lg-6 col-12 form-group">
                  <label for="firstname">{{ "FIRSTNAME" | translate }}:<sup class="text-danger">*</sup></label>
                  <input type="text" id="firstname" class="form-control {{ referentHasError('firstname') ? 'is-invalid' : '' }}" formControlName="firstname" />
                  <div class="invalid-feedback" *ngIf="referentForm.controls?.firstname?.errors?.minlength">{{ "MIN" | translate }} 2 {{ "CHARACTERS" | translate }}</div>
                  <div class="invalid-feedback" *ngIf="referentForm.controls?.firstname?.errors?.maxlength">{{ "MAX" | translate }} 255 {{ "CHARACTERS" | translate }}</div>
                  <div class="invalid-feedback" *ngIf="referentForm.controls?.firstname?.errors?.required">{{ "ERRORS.INSERT_NAME" | translate }}</div>
                </div>
                <div class="col-lg-6 col-12 form-group">
                  <label for="lastname">{{ "LASTNAME" | translate }}:<sup class="text-danger">*</sup></label>
                  <input type="text" id="lastname" class="form-control {{ referentHasError('lastname') ? 'is-invalid' : '' }}" formControlName="lastname" />
                  <div class="invalid-feedback" *ngIf="referentForm.controls?.lastname?.errors?.minlength">{{ "MIN" | translate }} 2 {{ "CHARACTERS" | translate }}</div>
                  <div class="invalid-feedback" *ngIf="referentForm.controls?.lastname?.errors?.maxlength">{{ "MAX" | translate }} 255 {{ "CHARACTERS" | translate }}</div>
                  <div class="invalid-feedback" *ngIf="referentForm.controls?.lastname?.errors?.required">{{ "ERRORS.INSERT_LASTNAME" | translate }}</div>
                </div>
                <div class="col-lg-6 col-12 form-group" *ngIf="!this.siteForm.value.external">
                  <label for="phone">{{ "PHONE" | translate }}:</label>
                  <input type="text" id="phone" class="form-control" formControlName="phone" />
                </div>
                <div class="col-lg-6 col-12 form-group">
                  <label for="email">{{ "EMAIL" | translate }}:<sup class="text-danger">*</sup></label>
                  <input type="text" id="email" class="form-control {{ referentHasError('email') ? 'is-invalid' : '' }}" formControlName="email" />
                  <div class="invalid-feedback" *ngIf="referentForm.controls?.email?.errors?.maxlength">{{ "MIN" | translate }} 2 {{ "CHARACTERS" | translate }}</div>
                  <div class="invalid-feedback" *ngIf="referentForm.controls?.email?.errors?.maxlength">{{ "MAX" | translate }} 255 {{ "CHARACTERS" | translate }}</div>
                  <div class="invalid-feedback" *ngIf="referentForm.controls?.email?.errors?.pattern">{{ "ERRORS.INVALID_CHARACTER_INSERTED" | translate }}</div>
                  <div class="invalid-feedback" *ngIf="referentForm.controls?.email?.errors?.required">{{ "ERRORS.INSERT_EMAIL" | translate }}</div>
                </div>
                <div class="col-6 mt-075" *ngIf="isEditModeReferent">
                  <button class="btn btn-outline-primary" (click)="resetEditModeReferent()">{{ "ALERT.BTN_CANCEL" | translate }}</button>
                </div>
                <div class="pb-2 text-right mt-075 col-12" [ngClass]="isEditModeReferent ? 'col-lg-6' : ''">
                  <button *ngIf="!isEditModeReferent" class="btn btn-primary" (click)="addReferent()">{{ "SAVE" | translate }}</button>
                  <button *ngIf="isEditModeReferent" class="btn btn-primary" (click)="editReferent()">{{ "EDIT" | translate }}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>
